document.addEventListener(
	"DOMContentLoaded",
	function () {
		testimonialsSlider();
	},
	false
);

function testimonialsSlider() {
	var slider = document.querySelector(".home-testimonials__slider");
	if (slider) {
		var slideObj = new Swiper(".home-testimonials__slider", {
			slidesPerView: 1,
			slidesPerGroup: 1,
			speed: 400,
			spaceBetween: 50,
			mousewheel: false,
			freeMode: false,
			grabCursor: true,
			autoHeight: true,
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 100,
				},
			},
			pagination: {
				el: ".swiper-pagination",
				dynamicBullets: false,
				clickable: true,
			},
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
		});
	}
}
